import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useLang } from "@/contexts/LanguageContext";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const { lang } = useLang();
  const [content, setContent] = useState(null);

  const load = useCallback(() => {
    api.get("/content").then((r) => setContent(r.data)).catch(() => setContent({}));
  }, []);

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    if (!content || !content.theme) return;
    const th = content.theme;
    const css = `:root{--vl-gold:${th.gold};--vl-gold-bright:${th.gold_bright};--vl-bg:${th.dark_bg};--vl-surface:${th.dark_surface};${th.dark_text ? `--vl-ivory:${th.dark_text};` : ""}${th.dark_muted ? `--vl-stone:${th.dark_muted};` : ""}}
html[data-theme="light"]{--vl-bg:${th.light_bg};--vl-surface:${th.light_surface};--vl-gold:${th.gold};--vl-gold-bright:${th.gold_bright};${th.light_text ? `--vl-ivory:${th.light_text};` : ""}${th.light_muted ? `--vl-stone:${th.light_muted};` : ""}}`;
    let el = document.getElementById("vl-theme");
    if (!el) { el = document.createElement("style"); el.id = "vl-theme"; document.head.appendChild(el); }
    el.textContent = css;
  }, [content]);

  // c() reads a localized text field from the active-language bucket, falling back to German.
  const c = useCallback((key, fb = "") => {
    if (!content) return fb;
    const bucket = content[lang] || content.de || {};
    const v = bucket[key];
    if (v != null && v !== "" && !(Array.isArray(v) && v.length === 0)) return v;
    const dv = (content.de || {})[key];
    if (dv != null && dv !== "" && !(Array.isArray(dv) && dv.length === 0)) return dv;
    return fb;
  }, [content, lang]);

  return (
    <ContentContext.Provider value={{ content, reload: load, c }}>
      {children}
    </ContentContext.Provider>
  );
}

export function useContent() {
  const x = useContext(ContentContext);
  if (!x) throw new Error("useContent must be used within ContentProvider");
  return x;
}
